module.exports = __webpack_public_path__ + "img/pro_ten_5.38eb211b.jpg";